import { MyPageProvider } from "components/context/myPageContext";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export type IOutletContext = {
  resvStat: "wait" | "done" | "cancel";
  setResvStat: Dispatch<SetStateAction<string>>;
};

export default function MyBookLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { rmPdNo } = useParams();

  const [resvStat, setResvStat] = useState("wait");

  const [Y, setY] = useState(0);

  const onScroll = () => {
    const scrollY = window.scrollY;
    setY(scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <MyPageProvider>
      <div>
        <div className={"sub-header" + " " + (Y > 20 ? "radius-0" : "")}>
          <ul className="w-full between-center">
            <li
              className={resvStat === "wait" ? "on" : ""}
              onClick={() => {
                setResvStat("wait");

                if (!!rmPdNo) {
                  navigate("/mypage/resv");
                  return;
                }
              }}
            >
              {t("sb_ttl_1_mpg")}
            </li>
            <li
              className={resvStat === "done" ? "on" : ""}
              onClick={() => {
                setResvStat("done");
                if (!!rmPdNo) {
                  navigate("/mypage/resv");
                  return;
                }
              }}
            >
              {t("sb_ttl_2_mpg")}
            </li>
            <li
              className={resvStat === "cancel" ? "on" : ""}
              onClick={() => {
                setResvStat("cancel");

                if (!!rmPdNo) {
                  navigate("/mypage/resv");
                  return;
                }
              }}
            >
              {t("sb_ttl_3_mpg")}
            </li>
          </ul>
        </div>
        <Outlet
          context={{
            resvStat,
            setResvStat,
          }}
        />
      </div>
    </MyPageProvider>
  );
}
